<template>
<div>
    <vue-element-loading
  :text="loading.text"
  spinner="ring"
  :color="loading.color"
  :active="loading.active"
  :is-full-screen="true"/>
</div>
</template>
<script>
import VueElementLoading from 'vue-element-loading'
import { setTimeout } from 'timers';
export default {
    components: {
      VueElementLoading
    },
    data () {
      return {
        loading: {
          text: 'Cerrando Sesión',
          color: '#222',
          active: true
        }
      }
  },
  created () {
    localStorage.clear()
    setTimeout(()=>{
      this.$router.replace('/login')
    }, 5000)
  }
}
</script>
